import { getSHA256Hash } from '../../../utils/sha256';

const formatItem = item => ({
  id: item.id,
  price: item.price,
  quantity: item.quantity,
});

const formatItemInTransaction = item => ({
  id: item.productId,
  price: item.price,
  quantity: item.quantity,
});

const formatItemInList = item => item.id;

export async function criteoViewBasket(criteoAccountId, user, items) {
  try {
    const deviceType = /iPad/.test(navigator.userAgent)
      ? 't'
      : /Mobile|iP(hone|od)|Android|BlackBerry|IEMobile|Silk/.test(
          navigator.userAgent
        )
      ? 'm'
      : 'd';
    const hashedEmail = await getSHA256Hash(user.email);

    window.criteo_q = window.criteo_q || [];
    window.criteo_q.push(
      { event: 'setAccount', account: criteoAccountId },
      { event: 'setEmail', email: hashedEmail, hash_method: 'sha256' },
      { event: 'setZipcode', zipcode: user.zipcode },
      { event: 'setSiteType', type: deviceType },
      {
        event: 'viewBasket',
        item: items.map(formatItem),
      }
    );
  } catch (err) {
    console.error('Criteo Tag Error', err);
  }
}

export async function criteoViewList(criteoAccountId, user, items) {
  try {
    const deviceType = /iPad/.test(navigator.userAgent)
      ? 't'
      : /Mobile|iP(hone|od)|Android|BlackBerry|IEMobile|Silk/.test(
          navigator.userAgent
        )
      ? 'm'
      : 'd';
    const hashedEmail = await getSHA256Hash(user.email);

    window.criteo_q = window.criteo_q || [];
    window.criteo_q.push(
      { event: 'setAccount', account: criteoAccountId },
      { event: 'setEmail', email: hashedEmail, hash_method: 'sha256' },
      { event: 'setZipcode', zipcode: user.zipcode },
      { event: 'setSiteType', type: deviceType },
      {
        event: 'viewList',
        item: items.map(formatItemInList),
      }
    );
  } catch (err) {
    console.error('Criteo Tag Error', err);
  }
}

export async function criteoTrackTransaction(
  criteoAccountId,
  user,
  items,
  orderId
) {
  try {
    const deviceType = /iPad/.test(navigator.userAgent)
      ? 't'
      : /Mobile|iP(hone|od)|Android|BlackBerry|IEMobile|Silk/.test(
          navigator.userAgent
        )
      ? 'm'
      : 'd';
    const hashedEmail = await getSHA256Hash(user.email);

    window.criteo_q = window.criteo_q || [];
    if (user.email) {
      window.criteo_q.push(
        { event: 'setAccount', account: criteoAccountId },
        { event: 'setEmail', email: hashedEmail, hash_method: 'sha256' },
        { event: 'setZipcode', zipcode: user.zipcode },
        { event: 'setSiteType', type: deviceType },
        {
          event: 'trackTransaction',
          id: orderId,
          item: items.map(formatItemInTransaction),
        }
      );
    } else {
      window.criteo_q.push(
        { event: 'setAccount', account: criteoAccountId },
        { event: 'setZipcode', zipcode: user.zipcode },
        { event: 'setSiteType', type: deviceType },
        {
          event: 'trackTransaction',
          id: orderId,
          item: items.map(formatItemInTransaction),
        }
      );
    }
  } catch (err) {
    console.error('Criteo Tag Error', err);
  }
}

export async function criteoViewHome(criteoAccountId, user) {
  try {
    const deviceType = /iPad/.test(navigator.userAgent)
      ? 't'
      : /Mobile|iP(hone|od)|Android|BlackBerry|IEMobile|Silk/.test(
          navigator.userAgent
        )
      ? 'm'
      : 'd';
    const hashedEmail = await getSHA256Hash(user.email);

    window.criteo_q = window.criteo_q || [];
    window.criteo_q.push(
      { event: 'setAccount', account: criteoAccountId },
      { event: 'setEmail', email: hashedEmail, hash_method: 'sha256' },
      { event: 'setZipcode', zipcode: user.zipcode },
      { event: 'setSiteType', type: deviceType },
      {
        event: 'viewHome',
      }
    );
  } catch (err) {
    console.error('Criteo Tag Error', err);
  }
}

export async function criteoViewItem(criteoAccountId, user, item) {
  try {
    const deviceType = /iPad/.test(navigator.userAgent)
      ? 't'
      : /Mobile|iP(hone|od)|Android|BlackBerry|IEMobile|Silk/.test(
          navigator.userAgent
        )
      ? 'm'
      : 'd';
    const hashedEmail = await getSHA256Hash(user.email);

    window.criteo_q = window.criteo_q || [];
    window.criteo_q.push(
      { event: 'setAccount', account: criteoAccountId },
      { event: 'setEmail', email: hashedEmail, hash_method: 'sha256' },
      { event: 'setZipcode', zipcode: user.zipcode },
      { event: 'setSiteType', type: deviceType },
      {
        event: 'viewItem',
        item: formatItemInList(item),
      }
    );
  } catch (err) {
    console.error('Criteo Tag Error', err);
  }
}

export async function criteoAddToCart(criteoAccountId, user, items) {
  try {
    const deviceType = /iPad/.test(navigator.userAgent)
      ? 't'
      : /Mobile|iP(hone|od)|Android|BlackBerry|IEMobile|Silk/.test(
          navigator.userAgent
        )
      ? 'm'
      : 'd';
    const hashedEmail = await getSHA256Hash(user.email);

    window.criteo_q = window.criteo_q || [];
    window.criteo_q.push(
      { event: 'setAccount', account: criteoAccountId },
      { event: 'setEmail', email: hashedEmail, hash_method: 'sha256' },
      { event: 'setZipcode', zipcode: user.zipcode },
      { event: 'setSiteType', type: deviceType },
      {
        event: 'addToCart',
        item: items.map(formatItem),
      }
    );
  } catch (err) {
    console.error('Criteo Tag Error', err);
  }
}
